import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ParameterConst } from './constant';

@Injectable({
  providedIn: 'root'
})
export class AlertaService {

  constructor(public snackBar: MatSnackBar) {}
  success(message: any) {
    if(typeof(message) === "string")
      this.showSnackBar(message + "",ParameterConst.CLASS_CSS_SUCCESS);
    if(message instanceof Object && typeof message["message"] != "undefined")
      this.showSnackBar(message["message"],ParameterConst.CLASS_CSS_SUCCESS);
    if(message instanceof Array && message.length > 0 && typeof message[0]["message"] != "undefined")
      this.showSnackBar(message[0]["message"],ParameterConst.CLASS_CSS_SUCCESS);
  }
  error(message: string) {
    this.showSnackBar(message,ParameterConst.CLASS_CSS_ERROR);
  }
  info(message: string) {
    this.showSnackBar(message,ParameterConst.CLASS_CSS_INFO);
  }
  warning(message: string) {
    this.showSnackBar(message,ParameterConst.CLASS_CSS_WARNING);
  }
  showSnackBar(message:string,classCss:string){
    let config = new MatSnackBarConfig();
   /* config.verticalPosition = ParameterConst.VERTICAL_POSTION;
    config.horizontalPosition = ParameterConst.HORIZONTAL_POSITION;
    config.duration = ParameterConst.TIEMPO_DURACION_ALERTA;*/
    config.panelClass = classCss;
    this.snackBar.open(message, 'X', config);
  }
 }